import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import { useState, useEffect } from 'react'
import * as Constants from "../Constants";
import { Skeleton } from 'primereact/skeleton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConnectedOverlayScrollHandler } from 'primereact/utils';


function Inputs() {

  const [gotData, setGotData] = useState(false);
  const [gotDataForTable, setGotDataForTable] = useState(false);
  const [data, setData] = useState([]);
  const [property, setProperty] = useState();
  const [company, setCompany] = useState();
  // const [companyOptions, setCompanyOptions] = useState([]);
  const [companyNamesData, setCompanyNamesData] = useState([]);
  const [propertyData, setPropertyData] = useState([]);
  const [securedCodi, setSecuredCodi] = useState();
  const [unsecuredCodi, setUnsecuredCodi] = useState();
  const [columns, setColumns] = useState([
        { field: 'Loading...1', header: 'Loading...' },
        { field: 'Loading...2', header: 'Loading...' },
        { field: 'Loading...3', header: 'Loading...' },
        { field: 'Loading...4', header: 'Loading...' }
      ])
  const codi_columns = [
    { field: 'securedCodi', header: 'Secured Codi' },
    { field: 'unsecuredCodi', header: 'Unsecured Codi' }
  ]

  const get_input_data_api = async (property_name) => {
      if (Constants.use_api) {
        try {
          const res = await fetch(`${Constants.url}/api/v1/section108/get_input_data/${company.code}?property=${property_name.code}`)
          if (res.ok) {
            const dataResponse = await res.json()
            // setGotData(true);
            setGotDataForTable(true)
            console.log(dataResponse)
            return dataResponse
          } else {
            console.log("ERROR: Something went wrong in get_input_data_api response Inputs. res:")
            console.log(res)
            return null
          }
        } catch(error) {
          console.log("ERROR: Something went wrong in get_input_data_api response Inputs.")
          return null
        }
      } else {
        await Constants.sleep(Constants.sleep_for_api_testing);
        setGotDataForTable(true)
        console.log("WARNING: Using fake data from Constants file in get_input_data_api API call.")
        return Constants.get_input_data_api_data[company.code][property_name.code]
      }
  }

  const get_codi_api = async () => {
    if (Constants.use_api) {
      try {
        const res = await fetch(`${Constants.url}/api/v1/section108/get_codi/${Constants.company_name}`)
        if (res.ok) {
          const dataResponse = await res.json()
          return dataResponse
        } else {
          console.log("ERROR: Something went wrong in get_codi_api response Inputs. res:")
          console.log(res)
          return null
        }
      } catch(error) {
        console.log("ERROR: Something went wrong in get_codi_api response Inputs.")
        return null
      }
    } else {
      await Constants.sleep(Constants.sleep_for_api_testing);
      console.log("WARNING: Using fake data from Constants file in get_codi_api API call.")
      return Constants.get_codi_api_data
    }
}

const update_codi_api = async (newSecuredCodi, newUnsecuredCodi) => {
  if (Constants.use_api) {
    try {
      const res = await fetch(`${Constants.url}/api/v1/section108/update_codi/${Constants.company_name}?secured_codi=${newSecuredCodi}&unsecured_codi=${newUnsecuredCodi}`)
      if (res.ok) {
        const dataResponse = await res.json()
        return dataResponse
      } else {
        console.log("ERROR: Something went wrong in update_codi_api response Inputs. res:")
        console.log(res)
        return null
      }
    } catch(error) {
      console.log("ERROR: Something went wrong in update_codi_api response Inputs.")
      return null
    }
  } else {
    await Constants.sleep(Constants.sleep_for_api_testing);
    console.log("WARNING: Using fake data from Constants file in update_codi_api API call.")
    return {"status": "Success"}
  }
}

  const get_legal_chart_api = async () => {
    if (Constants.use_api) {
      try {
        const res = await fetch(`${Constants.url}/api/v1/section108/get_legal_chart/${Constants.company_name}`)
        if (res.ok) {
          const dataResponse = await res.json()
          setGotData(true);
          return dataResponse
        } else {
          console.log("ERROR: Something went wrong in get_legal_chart_api response Inputs. res:")
          console.log(res)
          return null
        }
      } catch (error) {
        console.log("ERROR: Something went wrong in get_legal_chart_api response Inputs.")
        return null
      }
    } else {
      await Constants.sleep(Constants.sleep_for_api_testing);
      setGotData(true)
      console.log("WARNING: Using fake data from Constants file in get_legal_chart_api API call.")
      return Constants.get_legal_chart_api_data
    }
  }

  const get_property_names_api = async () => {
    if (Constants.use_api) {
      try {
        const res = await fetch(`${Constants.url}/api/v1/section108/get_property_names/${Constants.company_name}`)
        if (res.ok) {
          const dataResponse = await res.json()
          // setGotData(true);
          return dataResponse
        } else {
          console.log("ERROR: Something went wrong in get_property_names_api response Inputs. res:")
          console.log(res)
          return null
        }
      } catch (error) {
        console.log("ERROR: Something went wrong in get_property_names_api response Inputs.")
        return null
      }
    } else {
      await Constants.sleep(Constants.sleep_for_api_testing);
      console.log("WARNING: Using fake data from Constants file in get_property_names_api API call.")
      return Constants.get_property_names_api_data
    }
  }

  const update_cell_value_api = async (property_name, row, column, new_value) => {
    if (Constants.use_api) {
      try {
        const res = await fetch(`${Constants.url}/api/v1/section108/update_cell_value/${Constants.company_name}?property=${property_name.code}&row=${row}&column=${column}&new_value=${new_value}`)
        if (res.ok) {
          const dataResponse = await res.json()
          // setGotData(true);
          return dataResponse
        } else {
          console.log("ERROR: Something went wrong in update_cell_value_api response Inputs. res:")
          console.log(res)
          return null
        }
      } catch (error) {
        console.log("ERROR: Something went wrong in update_cell_value_api response Inputs.")
        return null
      }
    } else {
      await Constants.sleep(Constants.sleep_for_api_testing);
      setGotDataForTable(true)
      console.log("WARNING: Using fake data from Constants file in update_cell_value_api API call.")
      return {"status": "Success"}
    }
  }

  useEffect(() => {
    get_legal_chart_api().then(function(dataResponse) {
      setCompanyNamesData(dataResponse)
      // for (const [key, value] of Object.entries(dataResponse)) {
      //   traverse_entity_children(key, value)
      //   // setCompany({ name: key, code: key })
      // }
      // get_input_data_api().then(dataResponse2 => setData(dataResponse2))
    })
    get_codi_api().then(function(dataResponse2) {
      setSecuredCodi(dataResponse2["secured_codi"])
      setUnsecuredCodi(dataResponse2["unsecured_codi"])
    })
  }, []);

  var companyOptions = []

  function traverse_entity_children(parent, entity) {
    const add_data = { name: parent, code: parent }
    // for (var i=0; i<companyOptions.length; i++) {
    //   if (JSON.stringify(companyOptions[i]) !== JSON.stringify(add_data) ) {
    //     setCompanyOptions(companyOptions.push(add_data))
    //    }
    // }
    if (!companyOptions.includes(add_data)) {
      // setCompanyOptions(companyOptions.push(add_data))
      companyOptions.push(add_data)
    }
    for (const [key, value] of Object.entries(entity)) {
      traverse_entity_children(key, value)
    }
    // if (!companyOptions.includes(add_data)) {
    //   // setCompanyOptions(companyOptions.push(add_data))
    //   companyOptions.push(add_data)
    // }
  }

  if (companyNamesData) {
    for (const [key, value] of Object.entries(companyNamesData)) {
      traverse_entity_children(key, value)
    }
  }

  var propertyOptions = []

  for (const value in propertyData) {
    propertyOptions.push({ name: propertyData[value], code: propertyData[value] })
  }

    function onCellEditComplete(e) {
        let { rowData, newValue, field, originalEvent: event } = e;
        setGotDataForTable(false);
        update_cell_value_api(property, rowData["Property"], field, newValue).then(function(dataResponse) {
          // setCompanyNamesData(dataResponse)
          // for (const [key, value] of Object.entries(dataResponse)) {
          //   traverse_entity_children(key, value)
          //   // setCompany({ name: key, code: key })
          // }
          get_input_data_api(property).then(dataResponse2 => setData(dataResponse2["data"]))
        })
        // switch (field) {
        //   case "quantity":
        //   case "price":
        //     if (this.isPositiveInteger(newValue)) rowData[field] = newValue;
        //     else event.preventDefault();
        //     break;
    
        //   default:
        //     if (newValue.trim().length > 0) rowData[field] = newValue;
        //     else event.preventDefault();
        //     break;
        // }
    }

    function onCellEditCompleteForCodi(e) {
      let { rowData, newValue, field, originalEvent: event } = e;
      const newSecuredCodi = field === "securedCodi" ? newValue : rowData["securedCodi"]
      const newUnsecuredCodi = field === "unsecuredCodi" ? newValue : rowData["unsecuredCodi"]
      update_codi_api(newSecuredCodi, newUnsecuredCodi).then(function(dataResponse) {
        // setCompanyNamesData(dataResponse)
        // for (const [key, value] of Object.entries(dataResponse)) {
        //   traverse_entity_children(key, value)
        //   // setCompany({ name: key, code: key })
        // }
        get_codi_api().then(function(dataResponse2) {
          setSecuredCodi(dataResponse2["secured_codi"])
          setUnsecuredCodi(dataResponse2["unsecured_codi"])
        })
      })
  }

    function cellEditor(options) {
        // if (options.field === "price") return this.priceEditor(options);
        // else return textEditor(options);
        return textEditor(options)
    }

    function textEditor(options) {
        return (
          <InputText
            type="text"
            value={options.value}
            onChange={(e) => options.editorCallback(e.target.value)}
          />
        );
      }

      function taxBasisBodyTemplate(rowData) {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(rowData["Tax Basis - Initial"]);
      }

      function bookValueBodyTemplate(rowData) {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(rowData["Book Value"]);
      }

      function adjustmentsBodyTemplate(rowData) {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(rowData["Adjustments"]);
      }

      function onPropertyChange(e) {
        setProperty(e.value);
        if (e.value != null && company) {
          setGotDataForTable(false)
          // get_dataframe_column_names_api(e.value).then(function(dataResponse3) {
          //   var new_columns = []
          //   for (const value in dataResponse3) {
          //     new_columns.push({ field: dataResponse3[value], header: dataResponse3[value] })
          //   }
            // columns = new_columns
            // setColumns(new_columns)
            get_input_data_api(e.value).then(function(dataResponse2) {
              var new_columns = []
              for (const value in dataResponse2["columns"]) {
                new_columns.push({ field: dataResponse2["columns"][value], header: dataResponse2["columns"][value] })
              }
              setColumns(new_columns)
              setData(dataResponse2["data"])
              setProperty(e.value);
            })
          // })
        }
      }

      function onCompanyChange(e) {
        if (e.value != null) {
          get_property_names_api().then(dataResponse => setPropertyData(dataResponse))
          setProperty()
        }
        setCompany(e.value);
      }

      function selectedTemplate(option, props) {
        if (option) {
            return (
                <div className="country-item country-item-value">
                    {/* <img alt={option.name} src="images/flag/flag_placeholder.png" onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} className={`flag flag-${option.code.toLowerCase()}`} /> */}
                    <div>{option.name}</div>
                </div>
            );
        }

        return (
            <span>
                {props.placeholder}
            </span>
        );
    }

    function optionTemplate(option) {
      return (
          <div className="country-item">
              {/* <img alt={option.name} src="images/flag/flag_placeholder.png" onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} className={`flag flag-${option.code.toLowerCase()}`} /> */}
              <div>{option.name}</div>
          </div>
      );
  }

    return (
        <div>
            { gotData ? <h2>Inputs</h2> : <h2>Loading...</h2> }
            { <div className="card p-fluid">
                    <DataTable value={[{"securedCodi": securedCodi, "unsecuredCodi": unsecuredCodi}]} editMode="cell" className="editable-cells-table" responsiveLayout="scroll">
                        {
                            codi_columns.map(({ field, header }) => {
                              var body_value;
                                return <Column key={field} field={field} header={header} style={{ width: '50%' }} body={body_value}
                                    editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditCompleteForCodi} />
                            })
                        }
                    </DataTable>
                </div>
 }

            { companyOptions && propertyOptions && <div className="dropdown-demo">
                <div className="card" style={{ display: 'flex' }}>
                    <Dropdown value={company} options={companyOptions} onChange={onCompanyChange} optionLabel="name" filter showClear filterBy="name" placeholder={gotData ? "Select company" : "Loading companies..."}
                        valueTemplate={selectedTemplate} itemTemplate={optionTemplate} />
                    { company && 
                    <Dropdown value={property} options={propertyOptions} onChange={onPropertyChange} optionLabel="name" filter showClear filterBy="name" placeholder={gotData ? "Select property" : "Loading properties..."}
                    valueTemplate={selectedTemplate} itemTemplate={optionTemplate} /> }
                    { company && property && !gotDataForTable && <div style={{padding: '10px'}}><ProgressSpinner style={{width: '25px', height: '25px'}} strokeWidth="5" /></ div> }
                    { !Constants.use_api && <p style={{ fontStyle: 'italic', paddingLeft: '10px' }}>Note: Updating cells functionality is currently disabled.</p> }
                </div>
            </div> }
            {/* { company && property && columns && <h2>Data failed to load.</h2> } */}
            { company && property && columns && data && <div className="card p-fluid">
                <DataTable value={data} editMode="cell" className="editable-cells-table" filterDisplay="row" responsiveLayout="scroll">
                    {
                        columns.map(({ field, header }) => {
                            var body_value;
                            // if (field === "Book Value") {
                            //   body_value = bookValueBodyTemplate
                            // } else if (field == "Tax Basis - Initial") {
                            //   body_value = taxBasisBodyTemplate
                            // } else if (field == "Adjustments") {
                            //   body_value = adjustmentsBodyTemplate
                            // }
                            return <Column key={field} field={field} header={header} filter sortable style={{ width: '25%' }} body={body_value}
                                editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                        })
                    }
                </DataTable>
            </div> }
        </div>
    );
}

export default Inputs;